module.exports = __webpack_public_path__ + "static/media/Logo.52d4517b.png";